window.addEventListener('load', function () {
  // Thoda extra wait taake Swiper aur layout poori tarah stabilize ho jaye
  setTimeout(initStickySubcategory, 300);
});

function initStickySubcategory() {
  if (window.innerWidth > 767) return;

  var section = document.querySelector('#shopify-section-template--18486493249725__subcollection slide-section');
  if (!section) return;

  function getHeaderHeight() {
    var header = document.querySelector('header');
    return header ? header.getBoundingClientRect().height : 60;
  }

  var headerHeight = getHeaderHeight();
  var gap = 5;
  var lastScrollY = window.scrollY;

  var marker = document.createElement('div');
  marker.style.height = '0px';
  section.parentNode.insertBefore(marker, section);

  var spacer = document.createElement('div');
  spacer.style.display = 'none';
  section.parentNode.insertBefore(spacer, section.nextSibling);

  function setStuck(stuck) {
    if (stuck) {
      if (!section.classList.contains('js-sticky-fixed')) {
        spacer.style.height = section.getBoundingClientRect().height + 'px';
        spacer.style.display = 'block';
        section.classList.add('js-sticky-fixed');
      }
    } else {
      if (section.classList.contains('js-sticky-fixed')) {
        section.classList.remove('js-sticky-fixed');
        section.classList.remove('js-scroll-up');
        spacer.style.display = 'none';
      }
    }
  }

  function onScroll() {
    var currentScrollY = window.scrollY;
    var scrollingUp = currentScrollY < lastScrollY;
    lastScrollY = currentScrollY;

    if (section.classList.contains('js-sticky-fixed')) {
      if (scrollingUp) {
        section.classList.add('js-scroll-up');
      } else {
        section.classList.remove('js-scroll-up');
      }
    }
  }

  function createObserver() {
    return new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setStuck(entry.boundingClientRect.top < 0);
      });
    }, {
      rootMargin: '-' + (headerHeight + gap) + 'px 0px 0px 0px',
      threshold: 0
    });
  }

  var observer = createObserver();
  observer.observe(marker);

  window.addEventListener('scroll', onScroll, { passive: true });

  window.addEventListener('resize', function () {
    headerHeight = getHeaderHeight();
    observer.disconnect();
    observer = createObserver();
    observer.observe(marker);
  });
}